import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { qcArticle } from '@/mocks/articles';

export default function QualityCheckPage() {
  return <SeoArticlePage article={qcArticle} />;
}